import {Button, Grid} from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";

const MainActions = (props) => {

    return (
        <>
            <Grid container
                  justifyContent={"space-between"}
                  alignItems={"center"}>
                <Button variant={"outlined"}
                        color={"primary"}
                        onClick={props.handleDialogClose}>
                    Annulla
                </Button>

                <Button variant={"contained"}
                        color={"primary"}
                        disabled={props.selectedPlan === ""}
                        onClick={props.handleProceedClick}>
                    Prosegui
                </Button>
            </Grid>
        </>
    )
}

MainActions.propTypes = {
    handleDialogClose: PropTypes.func.isRequired,
    handleProceedClick: PropTypes.func.isRequired,
    selectedPlan: PropTypes.string.isRequired
}

export default MainActions
